import { render, staticRenderFns } from "./ItemDetailOpenMarketLayout.vue?vue&type=template&id=1db62e2b&scoped=true&"
import script from "./ItemDetailOpenMarketLayout.vue?vue&type=script&lang=js&"
export * from "./ItemDetailOpenMarketLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db62e2b",
  null
  
)

export default component.exports